/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleResponse } from './RoleResponse';
import {
    RoleResponseFromJSON,
    RoleResponseFromJSONTyped,
    RoleResponseToJSON,
    RoleResponseToJSONTyped,
} from './RoleResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface RoleResponsePagedResult
 */
export interface RoleResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof RoleResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<RoleResponse>}
     * @memberof RoleResponsePagedResult
     */
    data: Array<RoleResponse> | null;
}

/**
 * Check if a given object implements the RoleResponsePagedResult interface.
 */
export function instanceOfRoleResponsePagedResult(value: object): value is RoleResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function RoleResponsePagedResultFromJSON(json: any): RoleResponsePagedResult {
    return RoleResponsePagedResultFromJSONTyped(json, false);
}

export function RoleResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(RoleResponseFromJSON)),
    };
}

export function RoleResponsePagedResultToJSON(json: any): RoleResponsePagedResult {
    return RoleResponsePagedResultToJSONTyped(json, false);
}

export function RoleResponsePagedResultToJSONTyped(value?: RoleResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(RoleResponseToJSON)),
    };
}

